import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { LocalizedCurrencyText } from "../LocalizedCurrency";
export const ItemPrice = (props) => {
    const { price, quantity, discount, variant = "body2" } = props;
    const totalPrice = price * quantity;
    return (_jsxs(Stack, Object.assign({ direction: "row", justifyContent: "flex-end", flexWrap: "wrap", spacing: 0.5 }, { children: [_jsx(Typography, Object.assign({ variant: variant, sx: {
                    textDecorationLine: discount && discount > 0 ? "line-through" : undefined,
                } }, { children: _jsx(LocalizedCurrencyText, { value: totalPrice }) })), discount && discount > 0 ? (_jsx(Typography, Object.assign({ variant: variant }, { children: _jsx(LocalizedCurrencyText, { value: totalPrice - quantity * discount }) }))) : null] })));
};
